import {booleanAttribute, ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MøteModellEnkelMedProtokollinfo} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatListItemLine, MatListItemTitle, MatListOption, MatSelectionList} from "@angular/material/list";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {TranslateModule} from "@ngx-translate/core";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {EnumPipe} from "felles-ng2/pipes/EnumPipe";
import {MatTooltip} from "@angular/material/tooltip";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";

const debug = initDebugger('VelgMøteprotokollKomponent');

type SkjemaType = ReturnType<typeof VelgMøteprotokollKomponent.opprettSkjema>;

/**
 * Lar bruker velge en protokoll fra en liste over protokoller
 */
@Component({
    selector: 'velg-moeteprotokoll',
    templateUrl: 'velg-møteprotokoll.html',
    styleUrl: 'velg-møteprotokoll.scss',
    imports: [
        ReactiveFormsModule,
        MatSelectionList,
        MatListOption,
        FormaterPlainDatePipe,
        TranslateModule,
        ZonedDateTimeSomPlainDatePipe,
        EnumPipe,
        MatTooltip,
        MatListItemTitle,
        MatListItemLine
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgMøteprotokollKomponent {

    static opprettSkjema() {
        return new FormControl<MøteModellEnkelMedProtokollinfo[]>([], {nonNullable: true, validators: FeltValidatorer.ikkeTomListe});
    }

    kontroller = input.required<SkjemaType>();
    tilgjengeligeMoeter = input.required<MøteModellEnkelMedProtokollinfo[]>();
    tillatVelgFlere = input(false, {transform: booleanAttribute});
    ariaLabel = input<string | null>(null);
    ariaLabelledBy = input<string | null>(null);

    constructor() {

    }
}
